import React, { useState } from 'react';
import DealsBannerSlug from './DealsBannerSlug';
import DealsFilterCardsSlug from './DealsFilterCardsSlug';
import AllInclusiveSlug from './AllInclusiveSlug';
import FlightSlug from './Flight/FlightSlug';
import HotelSlug from './Hotel/HotelSlug';
import VacationsSlug from './VacationsSlug';
import CruisesSlug from './CruisesSlug';
import AdventuresSlug from './AdventuresSlug';
import ToursSlug from './ToursSlug';
import Favorite from '../../../assets/images/Favorite-bg5.png';
export default function DealSlugIndex() {
    const [selectedTab, setSelectedTab] = useState('AllInclusive');

    const renderDealsComponentSlug = () => {
        switch (selectedTab) {
            case 'AllInclusive':
                return <AllInclusiveSlug title="All Inclusive" />;
            case 'Flight':
                return <FlightSlug title="Flights" />;
            case 'Hotel':
                return <HotelSlug title="Hotels" />;
            case 'Vacations':
                return <VacationsSlug title="Vacations" />;
            case 'Tours':
                return <ToursSlug title="Tours" />;
            case 'Cruises':
                return <CruisesSlug title="Cruises" />;
            case 'Adventures':
                return <AdventuresSlug title="Adventures" />;
            default:
                return null;
        }
    };

    return (
        <>
            <DealsBannerSlug />
            <section className="section-equal-padding deals_section">
                <div className="container-fluid">
                    <DealsFilterCardsSlug
                        selectedTab={selectedTab}
                        setSelectedTab={setSelectedTab}
                    />
                    {renderDealsComponentSlug()}
                </div>
            </section>
            <section className="section-equal-padding favorite-section things-favorite uk-scrollspy-inview"
                style={{ backgroundImage: `url(${Favorite})` }}
                uk-scrollspy="cls: uk-animation-slide-bottom; delay: 400; repeat: false">
                <div className="container d-flex justify-content-center text-center">
                    <div className="favorite-block uk-scrollspy-inview"
                        uk-scrollspy="cls: uk-animation-slide-bottom; delay: 400; repeat: false">
                        <h2 className="mb-4">Get Ready for an Adventure!</h2>
                        <p>
                            Start your journey with us, where we guarantee the lowest prices. Book top hotel rooms for $20-$30
                            less per night and save $25-$50 on flights compared to other travel sites. Explore our site, grab
                            great deals, and let the thrill of savings fuel your dream getaway!
                        </p>
                        <a href="" className="white-btn mt-3">Browse Full Menu</a>
                    </div>
                </div>
            </section>
        </>
    );
}
